import { CLESSON_MODES } from '@yandex-int/k-common/constants';
import { H5, HumanDate, Popup, Text } from 'platform-components';
import { POPUP_THEMES } from 'platform-components/constants';
import PropTypes from 'prop-types';
import React from 'react';

import './course-journal__lesson-description.scss';

const getCLessonModeTextId = (mode) => {
    switch (mode) {
        case CLESSON_MODES.LESSON:
            return 'courseJournal.lessonDescription.clessonMode.lesson';
        case CLESSON_MODES.CONTROL_WORK:
            return 'courseJournal.lessonDescription.clessonMode.controlWork';
        default:
            return '';
    }
};

export class CourseJournalLessonDescription extends React.Component {
    static propTypes = {
        direction: PropTypes.string,
    };

    state = {
        id: null,
        name: '',
        dateAssignment: null,
        owner: '',
        mode: null,
    };

    componentDidMount() {
        this.refs.popup.hide();
    }

    shouldComponentUpdate(nextProps, nextState) {
        return this.state.id !== nextState.id || this.props.direction !== nextProps.direction;
    }

    show = (nextState) => {
        this.setState(nextState);
        this.refs.popup.setOwner(nextState.owner).show();
    };

    hide = () => {
        this.refs.popup.hide();
    };

    render() {
        const { direction } = this.props;
        const { name, dateAssignment, mode } = this.state;
        const clessonModeTextId = getCLessonModeTextId(mode);

        return (
            <Popup
                direction={direction}
                inLayer
                mix={'course-journal__lesson-description'}
                offsetTop={6}
                ref={'popup'}
                selfclosable
                theme={POPUP_THEMES.DARK}
            >
                <H5 id={'courseJournal.lessonDescription.name'} values={{ name }} />

                <div className={'course-journal__cell-description-row'}>
                    <div className={'course-journal__cell-description-property'}>
                        <Text id={clessonModeTextId} />
                    </div>
                </div>

                <div className={'course-journal__cell-description-row'}>
                    <div className={'course-journal__cell-description-property'}>
                        <Text id={'courseJournal.lessonDescription.assignmentDateKey'} />
                    </div>
                    <div className={'course-journal__cell-description-value'}>
                        <Text>
                            <HumanDate date={dateAssignment} />
                        </Text>
                    </div>
                </div>
            </Popup>
        );
    }
}
